import request from "../../utils/request";
import Qs from "qs";
import cloneDeep from "lodash-es/cloneDeep";
import isFunction from "lodash-es/isFunction";
import { buildProps } from "../../utils/props";
import { ref } from "vue";
import type { ExtractPropTypes, PropType, Ref, SetupContext } from "vue";
import { FetchDataTypeConf, FetchTypeConf } from "./types";
import type { AfterSuccessFuncType, AfterErrorFuncType, FetchDataFilterType, FetchDataTypeConfKeyType, FetchTypeConfKeyType, IsSuccessType, ResDataFilterType, UrlFunctionType, FetchApiInterface, OnSubmitSuccessType, OnSubmitErrorType, DefaultResDataFilterType, SubmitToSeverOperateType, DisabledFetchFilterType, ChangeLoadingStatusInterface, GetFileFuncInterface } from "./types";
import type { Method } from "axios";
import { ElMessageBox, ElMessage } from "element-plus";
/*
  submitToSever * 常用的提交接口封装；
*/
export const submitToSeverProps = buildProps({
  /**
   * 配置请求实例,promise fetch对象
   */
  fetchApi: {
    type: [Boolean, Function as PropType<FetchApiInterface>],
    default: false,
  },
  /**
   * 配置查询的url
   */
  url: {
    type: [String, Function as PropType<UrlFunctionType>],
    default: "",
  },

  /**
   * 配置查询的方式
   */
  fetchType: {
    type: String as PropType<Method>,
    values: Object.keys(FetchTypeConf).map(
      (key) => FetchTypeConf[key as FetchTypeConfKeyType]
    ),
    default: FetchTypeConf.GET,
  },

  /**
   * 配置查询带的数据
   */
  fetchData: {
    type: [Object, Array, String],
    default: () => ({}),
  },
  /**
   * 配置提交的成功的默认提示
   */
  successText: {
    type: String,
    default: "提交成功",
  },

  /**
   * 通过请求的数据过滤是否发起请求方法
   */
  disabledFetchFilter: {
    type: Function as PropType<DisabledFetchFilterType>,

    default: <T>(res: T): boolean => {
      return false;
    },
  },

  /**
   * 配置查询的数据过滤方法
   */
  fetchDataFilter: {
    type: Function as PropType<FetchDataFilterType>,

    default: (res: unknown): unknown => res,
  },
  /**
   * 配置请求的数据的提交方式，可以为json或者form
   */
  fetchDataType: {
    type: String,
    values: Object.keys(FetchDataTypeConf).map(
      (key) => FetchDataTypeConf[key as FetchDataTypeConfKeyType]
    ),
    default: FetchDataTypeConf.JSON,
  },
  /**
   * 配置请求成功后的数据回调
   */
  onSubmitSuccess: {
    type: Function as PropType<OnSubmitSuccessType>,
    default: (res: unknown) => res,
  },
  /**
   * 提交失败后的回调
   */
  onSubmitError: {
    type: Function as PropType<OnSubmitErrorType>,
    default: (res: unknown) => res,
  },
  /**
   * 默认提交的fetch的配置
   */
  fetchConfig: {
    type: Object,
    default: () => ({}),
  },
  /**
   * 配置请求成功后返回的数据是否是成功数据
   */
  isSuccess: {
    type: Function as PropType<IsSuccessType>,
    default: (res: any): boolean => !!res,
  },
  /**
   * 默认返回数据的过滤参数
   */
  defaultResFilter: {
    type: Function as PropType<DefaultResDataFilterType>,
    default: (res: any): any => res,
  },
  /**
   * 配置返回的数据过滤方法
   */
  resDataFilter: {
    type: Function as PropType<ResDataFilterType>,
    default: (res: any): any => res,
  },
  /**
   * 以新打开界面形式提交
   */
  getFile: {
    type: Boolean,
    default: false,
  },
  /**
   *  成功是否提示信息
   */
  showSuccessTip: {
    type: Boolean,
    default: true,
  },
  /**
   *  失败是否提示信息
   */
  showErrorTip: {
    type: Boolean,
    default: false,
  },
});
type SubmitToSeverPropsType = ExtractPropTypes<typeof submitToSeverProps>;
export default function (
  props: SubmitToSeverPropsType,
  ctx: SetupContext<unknown>,
  config: {
    afterSuccessFunc: AfterSuccessFuncType;
    afterErrorFunc: AfterErrorFuncType;
  }
): SubmitToSeverOperateType {
  const loading: Ref<boolean> = ref(false);
  /**
   * 打开文件的方法
   * @param  {Object} fetchData 要提交的数据
   */
  const getFileFunc: GetFileFuncInterface = (fetchData: any): void => {
    console.log("downfile");
  };
  /**
   * 设置是否加载中
   * @param  {Boolean} type 是否加载中
   */
  const changeLoadingStatus: ChangeLoadingStatusInterface = (
    type: boolean
  ): void => {
    loading.value = type;
    ctx.emit("submitLoadingStatusChange", type);
  };
  /**
   * 请求数据的方法
   * @param  {Object} fetchData 请求的数据
   *  @param  {Function} disabledFilter 经过前置提交数据过滤方法
   */
  const goFetchFunc = async function (
    fetchData: any = props.fetchData,
    disabledFetchFilter: DisabledFetchFilterType = props.disabledFetchFilter
  ) {
    if (loading.value) return;
    let goFetch = true; // 是否提交的方法
    if (!props.url && !props.fetchApi) return;
    const setUrl: string = isFunction(props.url)
      ? props.url(props.fetchData)
      : props.url;
    if (!setUrl && !props.fetchApi) return;

    fetchData = props.fetchDataFilter(fetchData); // 经过前置提交数据过滤方法

    goFetch = !disabledFetchFilter(fetchData); // 经过前置提交方法判断

    let setFetchConfig = { ...props.fetchConfig };
    if (props.fetchDataType == FetchDataTypeConf.FORM) {
      setFetchConfig = {
        ...setFetchConfig,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        transformRequest: [
          function (data: unknown) {
            data = Qs.stringify(data);
            return data;
          },
        ],
      };
    }

    if (goFetch) {
      changeLoadingStatus(true);
      if (props.getFile) {
        // 如果为跳转提交则进入跳转提交
        getFileFunc(fetchData);
        return;
      }

      try {
        let res: any;
        if (!props.url && props.fetchApi && isFunction(props.fetchApi)) {
          res = await props.fetchApi(fetchData, setFetchConfig);
        } else {
          res = await request({
            url: setUrl,
            method: props.fetchType as Method,
            [props.fetchType == FetchTypeConf.GET ? "params" : "data"]:
              fetchData,
            ...setFetchConfig,
          });
        }

        if (props.defaultResFilter) {
          res = props.defaultResFilter(res);
        }
        changeLoadingStatus(false);
        if (props.isSuccess(res)) {
          if (typeof config.afterSuccessFunc == "function") {
            config.afterSuccessFunc(res, fetchData);
          }
          ctx.emit("submitSuccess", res, fetchData, ctx);
          if (props.showSuccessTip) {
            ElMessage({
              message: res.message || res.msg || props.successText,
              type: "success",
            });
          }
          // this.onSuccessReset();
        } else {
          throw res || {};
        }
      } catch (err: Error | any) {
        console.log(err);
        changeLoadingStatus(false);
        const resText = err.message ? err.message : err.msg || "系统错误";
        if (typeof config.afterErrorFunc == "function") {
          config.afterErrorFunc(err, fetchData);
        }
        ctx.emit("submitError", err, fetchData, ctx);
        if (props.showErrorTip) {
          ElMessageBox({
            title: resText,
            type: "error",
          });
        }
      }
    }
  };
  return {
    loading,
    changeLoadingStatus,
    getFileFunc,
    goFetchFunc,
  };
}
